"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutType = void 0;
var LayoutType;
(function (LayoutType) {
    LayoutType["MAIN"] = "Main";
    LayoutType["MAIN_YOLO"] = "MainYolo";
    LayoutType["PROFILE_QUESTIONNAIRES"] = "ProfileQuestionnaires";
    LayoutType["EXCLUSIVE_ACCESS"] = "ExclusiveAccess";
    LayoutType["HEADER"] = "Header";
    LayoutType["REVIEWS"] = "Reviews";
    LayoutType["OPENID"] = "OpenId";
    LayoutType["ATP_INCENTIVE"] = "ATPIncentive";
    LayoutType["COPILOT_INCENTIVE"] = "CopilotIncentive";
})(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
